import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER } from "src/constant/common";

const WindAndDisturbanceSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.wind_and_disturbance_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`)}
          name={`MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_SPEED_AT_INITIAL_ALTITUDE}`) })}
          unit="m/s"
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`)}
          name={`MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.WIND_DIRECTION_AT_INITIAL_ALTITUDE}`) })}
          unit="deg"
        />
      </div>
    </div>
  );
};

export default WindAndDisturbanceSigma;
